import { SyntheticEvent, useState } from 'react';
import { TextField, Autocomplete as MuiAutocomplete } from '@mui/material';
import { Season } from '@common-types';

import { renderNoOptionsText } from '@components/Form/Autocomplete/Autocomplete';

import { AutocompleteOption } from '@interfaces';

interface AttendingCollegeAutocompleteProps {
  attendingYear?: number;
  handleAttendingCollegeChange: (grade: string | undefined) => void;
}

export const AttendingCollegeAutocomplete = (props: AttendingCollegeAutocompleteProps) => {
  const { handleAttendingCollegeChange, attendingYear } = props;

  const [attendingCollege, setAttendingCollege] = useState<AutocompleteOption | null>(null);

  const options = [];

  if (attendingYear) {
    options.push({ value: `${Season.FALL}, ${attendingYear}`, label: `${Season.FALL}, ${attendingYear}` });
    options.push({ value: `${Season.SPRING}, ${attendingYear + 1}`, label: `${Season.SPRING}, ${attendingYear + 1}` });
  }

  options.push({ value: 'inOverAYear', label: 'In over a year' });
  options.push({ value: 'notSure', label: 'Not Sure' });

  const onAttendingCollegeChange = (event: SyntheticEvent, beginCollege: AutocompleteOption | null) => {
    setAttendingCollege(beginCollege);

    handleAttendingCollegeChange(beginCollege?.value);
  };

  return (
    <MuiAutocomplete
      data-testid="attendingCollegeAutocomplete"
      options={options}
      renderInput={(params) => <TextField {...params} label="When do you plan on attending college?" />}
      clearIcon={null}
      value={attendingCollege}
      onChange={onAttendingCollegeChange}
      noOptionsText={renderNoOptionsText()}
      isOptionEqualToValue={(option, value) => option.value === value.value}
    />
  );
};
